import React, { type FC, useCallback, useState } from "react";

import { AuthLayout } from "../AuthLayout";
import { Login2faForm } from "./Login2faForm";
import { LoginForm, type LoginFormValues } from "./LoginForm";
import { LogoHeader } from "../LogoHeader";

export const LoginView: FC = () => {
    const [use2fa, setUse2fa] = useState(false);
    const [credentials, setCredentials] = useState<LoginFormValues | null>(null);

    const hide2fa = useCallback(() => setUse2fa(false), []);
    const show2fa = useCallback((values: LoginFormValues) => {
        setUse2fa(true);
        setCredentials(values);
    }, []);

    return (
        <AuthLayout>
            <LogoHeader />

            {use2fa && <Login2faForm hide2fa={hide2fa} credentials={credentials} />}
            {!use2fa && <LoginForm show2fa={show2fa} />}
        </AuthLayout>
    );
};
